<template>
    <div
        class="event-card gcmcn-card"
        :class="{'selected-element' : selectedEventUid === event.uid}"
        @click="showEventDetails"
    >
        <img class="event-img" :src="event.logo">
        <div>
            <span class="event-name">{{ event.name }}</span>
            <span v-if="!condensed"> | {{universe ? universe.display_name : 'no universe'}}</span>
        </div>
        <i
            v-if="!condensed"
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : selectedEventUid === event.uid}"
        ></i>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

    components: {

    },

    props: {
        event: {
            type: Object,
            required: true
        },
        selectedEventUid: {
            type: String,
            required: true
        },
        universe: {
            type: Object,
            required: true
        },
        condensed: {
            type: Boolean,
            default: false
        }
    },

    data: function(){
        return {
        };
    },

    computed: {
        ...mapGetters([
            'userHasMultipleEntities',
            'entitiesByUid',
        ]),
        entity() {
            return this.entitiesByUid(this.event.scopes.entity_uid);
        },
    },

    methods: {
        showEventDetails() {
            this.$emit('changeSelectedEvent', this.event.uid);
        }
    },
};
</script>

<style lang="scss">
.event-card {
    display: flex;
    position: relative;
    cursor: pointer;
    .event-img{
        height: 50px;
        margin-right: 15px;
    }
    .event-name{
        font-weight: bold;
    }
    +.event-card {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/eventCard.vue